import { Assessment, Question } from "./types";

export function validateResults(
  currentAssessment: Assessment,
  completeAssessment: Assessment,
  selectedAnswers: Record<string, string>
) {
  const resultData = JSON.parse(
    JSON.stringify(currentAssessment)
  ) as Assessment;
  const resultState = resultData.assessment_state;
  const resultUi = resultData.assessment_ui;
  let numberCorrect = 0;
  resultState.attempts++;
  resultUi.questions = resultUi.questions.map<Question>(
    (question, questionIndex) => {
      question.options = question.options.map((option, optionIndex) => {
        if (selectedAnswers[question.id] === option.id) {
          const answerKey =
            completeAssessment.assessment_ui.questions[questionIndex].options[
              optionIndex
            ];
          if (answerKey.correct) {
            numberCorrect++;
          }
          return answerKey;
        }
        return option;
      });
      return question;
    }
  );
  if (numberCorrect === resultUi.questions.length) {
    resultState.completed = true;
    resultState.points_earned =
      resultState.points_available /
      (resultState.attempts < 3 ? resultState.attempts : 4);
    resultState.points_available = 0;
    resultState.points_available_next = 0;
    resultData.assessment_ui = completeAssessment.assessment_ui;
    resultData.call_to_action = completeAssessment.call_to_action;
    resultData.legacy_rewards = completeAssessment.legacy_rewards;
  }
  return resultData;
}
